import Vue from 'vue';
import Vuelidate from 'vuelidate';
import Multiselect from 'vue-multiselect';

Vue.use(Vuelidate);
Vue.component('Multiselect', Multiselect);
